// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconBackNavigationPath = 'M18.387 9.89a3.948 3.948 0 0 0-3.509-2.08H4.235l3.633-4.359L6.331 2.17l-5 6c-.308.371-.308.91 0 1.281l5 6 1.537-1.281-3.633-4.36h10.643c.742 0 1.398.389 1.754 1.04.357.651.331 1.413-.013 1.958l-2.972 3.776 1.572 1.238 3.03-3.856c.8-1.25.851-2.774.138-4.076Z';
var IconBackNavigation = baseIcon('IconBackNavigation', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconBackNavigationPath
});
export default IconBackNavigation;
//# sourceMappingURL=index.js.map